module.exports = __webpack_public_path__ + "tabletSlide.webp?76bf7f19d69a16e5f56c3816cdf9fcf3";